export enum UpiAccountTypes {
	CREDIT_CARD = 'CREDIT_CARD',
	CREDIT_LINE = 'CREDIT_LINE',
	LITE = 'LITE',
	DEBIT = 'DEBIT',
	SAVINGS = 'SAVINGS',
	SOD = 'SOD',
}
export const androidPermissions = ['SEND_SMS', 'READ_PHONE_STATE', 'READ_SMS'];

export const defaultUpiTimeout = 10000;

export enum CarrierNames {
	Airtel = 'airtel',
	Bsnl = 'bsnl',
	Mtnl = 'mtnl',
	Vi = 'vi',
	Jio = 'jio',
}
